/* メニュー(職員) */
import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { handleBrowserBack } from '../../BrowserBack';
import { organization_type } from '../../Const';
import Maintenance from '../../molecules/Maintenance';
import StaffNavbar from '../../molecules/StaffNavbar';

const MaintenanceMenu: React.FC = () => {
  // 農林中央金庫ユーザーフラグ
  const [isNourin, setIsNourin] = useState(false);

  const node = document.getElementById('maintenance-menu');
  const [role, setRole] = useState('');
  const [has_loan_aproval_system, setHasLoanAprovalSystem] = useState(false);

  // メールテンプレート管理ボタンを押下する
  const handleClickMailTemplate = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/maintenance/mail_template`;
  };

  // 同意文言管理ボタンを押下する
  const handleClickReceptionList = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/maintenance/clause`;
  };

  // 掲載書類管理ボタンを押下する
  const handleClickDisplayedDocuments = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/maintenance/displayed_documents`;
  };

  // ロールを設定する
  const setUserRole = () => {
    if (node === null) {
      // nodeが正しく取得できない場合は空文字とする
      setRole('');
      setHasLoanAprovalSystem(false);
      return;
    }

    // ロール名をセット
    setRole(node.dataset.role as string);

    // 融資稟議システム導入済みフラグをセット
    if ((node.dataset.has_loan_aproval_system as string) === '1') {
      setHasLoanAprovalSystem(true);
    } else {
      setHasLoanAprovalSystem(false);
    }

    // 組織区分コードをセット
    const user_organization = node?.dataset.organization_type as string;
    setIsNourin(user_organization === organization_type.nourin);
  };

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();

    // ユーザロールを設定する
    setUserRole();
  }, []);

  return (
    <>
      <StaffNavbar user_role={role} has_loan_aproval_system={has_loan_aproval_system} />
      <Maintenance active={null}>
        <div className="d-flex flex-column align-items-center">
          {!isNourin && (
            <a
              onClick={handleClickMailTemplate}
              className="btn btn-xl btn-outline-success w-75 mb-5 py-3 btn-text-color"
            >
              メールテンプレート管理
            </a>
          )}
          <a
            onClick={handleClickReceptionList}
            className="btn btn-xl btn-outline-success w-75 mb-5 py-3 btn-text-color"
          >
            同意文言管理
          </a>
          {!isNourin && (
            <a
              onClick={handleClickDisplayedDocuments}
              className="btn btn-xl btn-outline-success w-75 mb-5 py-3 btn-text-color"
            >
              掲載書類管理
            </a>
          )}
        </div>
        <div className="d-flex justify-content-center">
          <a
            className="btn btn-mini btn-outline-success btn-text-color"
            href={`${location.origin}${process.env.MIX_MOCK_URL}/staff/menu`}
          >
            戻る
          </a>
        </div>
      </Maintenance>
    </>
  );
};

if (document.getElementById('maintenance-menu')) {
  ReactDOM.render(<MaintenanceMenu />, document.getElementById('maintenance-menu'));
}
